import { useCallback as d } from "react";
import { useSingleSelectContext as l } from "../SingleSelectContext.js";
const S = ({
  selectedValue: t,
  searchValue: e,
  creatableProps: n
}) => {
  const {
    addCreatedSection: o,
    isSuggestionVisible: i
  } = l(), r = t?.value === e;
  return {
    handleKeyDown: d((s) => {
      n && s.key === "Enter" && e.trim() && i && !r && o();
    }, [t, e])
  };
};
export {
  S as useKeyboard
};
